import { render, staticRenderFns } from "./NewPieceFormItem.vue?vue&type=template&id=532a790f&scoped=true&lang=pug"
import script from "./NewPieceFormItem.vue?vue&type=script&lang=js"
export * from "./NewPieceFormItem.vue?vue&type=script&lang=js"
import style0 from "./NewPieceFormItem.vue?vue&type=style&index=0&id=532a790f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a790f",
  null
  
)

export default component.exports